export function generateX(mu, sigma, numPoints = 100) {
  const rangeMultiplier = 4;
  const start = Math.max(0, mu - rangeMultiplier * sigma); // clamp to 0
  const end = mu + rangeMultiplier * sigma;
  const step = (end - start) / numPoints;

  const labels = [];
  for (let i = 0; i <= numPoints; i++) {
    const x = start + i * step;
    labels.push(parseFloat(x.toFixed(2)));
  }

  return labels;
}

export function generateXforMultipleMuSigma(
  muSigmaPairs,
  minimum_target_thickness = null,
  maximum_target_thickness = null,
) {
  let minStart = Infinity;
  let maxEnd = -Infinity;

  if (minimum_target_thickness !== null) {
    minStart = minimum_target_thickness - 4;
  }

  if (maximum_target_thickness !== null) {
    maxEnd = maximum_target_thickness + 4;
  }

  muSigmaPairs.forEach(([mu, sigma]) => {
    const start = Math.max(0, mu - 6 * sigma);
    const end = mu + 8 * sigma;
    if (start < minStart) minStart = start;
    if (end > maxEnd) maxEnd = end;
  });

  const spread = maxEnd - minStart;
  const step = spread < 5 ? 0.05 : spread < 20 ? 0.1 : 0.5;

  minStart = Math.max(0, minStart);

  const xValues = [];
  for (let i = minStart; i <= maxEnd; i += step) {
    xValues.push(parseFloat(i.toFixed(2)));
  }

  return xValues;
}

export function gaussian(x, mu, sigma) {
  const gaussianConstant = 1 / Math.sqrt(2 * Math.PI);
  const new_x = (x - mu) / sigma;
  return (gaussianConstant * Math.exp(-0.5 * new_x * new_x)) / sigma;
}

export function generateY(sigma, mu) {
  const xValues = generateX(mu, sigma);
  const normalizationFactor = 1 / gaussian(mu, mu, sigma); // peak normalization

  return xValues.map(x => {
    const y = gaussian(x, mu, sigma) * normalizationFactor;
    return parseFloat(y.toFixed(5));
  });
}

export function generateYwithXvalues(sigma, mu, xValues) {
  const normalizationFactor = 1 / gaussian(mu, mu, sigma); // peak normalization

  return xValues.map(x => {
    const y = gaussian(x, mu, sigma) * normalizationFactor;
    return parseFloat(y.toFixed(5));
  });
}

export function calculateMu(measurements) {
  if (!measurements || measurements.length === 0) return 0;
  if (typeof measurements === "string") {
    measurements = JSON.parse(measurements);
  }

  const validMeasurements = measurements.filter(m => m !== null && m !== "");
  const sum = validMeasurements.reduce((a, b) => a + b, 0);
  return parseFloat((sum / validMeasurements.length).toFixed(2));
}

export function calculateSigma(measurements, mu) {
  if (typeof measurements === "string") {
    measurements = JSON.parse(measurements);
  }

  const validMeasurements = measurements.filter(m => m !== null && m !== "");
  if (validMeasurements.length < 2) return 0.01;

  const variance = validMeasurements.reduce((sq, n) => sq + Math.pow(n - mu, 2), 0) / validMeasurements.length;
  const sigma = Math.sqrt(variance);
  return Math.max(parseFloat(sigma.toFixed(2)), 0.01);
}
